import React from "react"

import SectionHeader from "./section-header"

const CallToAction = () => (
  <div style={{ padding: "4rem 1rem", textAlign: "center" }}>
    <SectionHeader
      title="Stay Updated"
      description="Give a final call to action because that's what the cool kids are doing."
    />
    <button onclick="https://forms.gle/8tJgdkfm3NC2Skz46;"> Get Early Access</button>

  </div>
)

export default CallToAction
